module.exports = __webpack_public_path__ + "static/media/checkmark.31d6b389.svg";